import { err, ok, Result } from "neverthrow";
import GraphqlApiError from "@/framework/network/gql/GraphqlApiError";

// Validate Key and remove "__typename" from response
export const removeTypename = <T>(obj?: T, skipNullCheck: boolean = false): Result<T, GraphqlApiError> => {
  const removeTypenameRecursive = (value: any): any => {
    if (Array.isArray(value)) {
      return value.map(removeTypenameRecursive);
    } else if (value !== null && typeof value === "object") {
      const newObj: any = {};
      for (const [key, val] of Object.entries(value)) {
        if (key !== "__typename") {
          newObj[key] = removeTypenameRecursive(val);
        }
      }
      return newObj;
    }
    return value;
  };

  if (obj === undefined) {
    return err(
      new GraphqlApiError(
        GraphqlApiError.Type.parseError,
        undefined,
        undefined,
        "Response is undefined. Error while parsing response."
      )
    );
  }

  if (obj === null && !skipNullCheck) {
    return err(
      new GraphqlApiError(
        GraphqlApiError.Type.parseError,
        undefined,
        undefined,
        "Response is null. Error while parsing response."
      )
    );
  }

  return ok(removeTypenameRecursive(obj));
};
